/** React Query: dados considerados frescos por 5 minutos (padrão lista/detalhe inspeções e proposta). */
export const STALE_TIME_FIVE_MINUTES_MS = 1000 * 60 * 5;

/** React Query: dados considerados frescos por 30 segundos (listas que recebem itens novos com frequência, ex.: inspeções). */
export const STALE_TIME_THIRTY_SECONDS_MS = 1000 * 30;
